// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-product-js": () => import("/tmp/build_aeb2b325/src/templates/product.js" /* webpackChunkName: "component---src-templates-product-js" */),
  "component---src-templates-category-js": () => import("/tmp/build_aeb2b325/src/templates/category.js" /* webpackChunkName: "component---src-templates-category-js" */),
  "component---src-templates-subcategory-js": () => import("/tmp/build_aeb2b325/src/templates/subcategory.js" /* webpackChunkName: "component---src-templates-subcategory-js" */),
  "component---src-pages-404-js": () => import("/tmp/build_aeb2b325/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cart-js": () => import("/tmp/build_aeb2b325/src/pages/cart.js" /* webpackChunkName: "component---src-pages-cart-js" */),
  "component---src-pages-index-js": () => import("/tmp/build_aeb2b325/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-search-js": () => import("/tmp/build_aeb2b325/src/pages/search.js" /* webpackChunkName: "component---src-pages-search-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/tmp/build_aeb2b325/.cache/data.json")

